import React from 'react'

import SvgIcon from './svgIcon'

const data = {
  id: 'facebook',
  viewBox: '0 0 24 24',
  children: [
    {
      name: 'path',
      transform: 'translate(-383.676 -772.261)',
      d: 'M407.676,784.334A12,12,0,1,0,393.8,796.261v-8.436h-3.047v-3.49H393.8v-2.659c0-3.026,1.792-4.7,4.533-4.7a18.3,18.3,0,0,1,2.686.236v2.971h-1.513a1.74,1.74,0,0,0-1.956,1.886v2.265h3.328l-.532,3.49h-2.8v8.436A12.053,12.053,0,0,0,407.676,784.334Z',
    },
  ],
}

const Icon = (props) => {
  return (
    <SvgIcon
      {...props}
      data={data}
    />
  )
}

export default Icon
